import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=6d9583aa&scoped=true&"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js&"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&id=6d9583aa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9583aa",
  null
  
)

export default component.exports